import { CpsUiAdminConfigWriteType } from '@cs-cms/types';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import ServicesContext from '../../contexts/ServicesContext';
import { uiAdminConfigsKeys } from '../../queryKeys/uiAdminConfigs';

export function useGetUiAdminConfigWritePermissions(
  keys?: string[]
): UseQueryResult<CpsUiAdminConfigWriteType, unknown> {
  const servicesCtx = useContext(ServicesContext);

  const getUiAdminConfigEntry = () => {
    if (servicesCtx?.uiAdminConfigsService && keys) {
      return servicesCtx.uiAdminConfigsService.getUiAdminConfigWritePermissions(keys);
    }
    throw new Error('Services context not initialized');
  };

  return useQuery({
    queryKey: uiAdminConfigsKeys.uiAdminConfigWritePermissions(keys),
    queryFn: getUiAdminConfigEntry,
    enabled: !!keys && keys.length > 0,
    retry: 0,
    staleTime: Infinity,
    gcTime: 28800000
  });
}
